module.exports = __webpack_public_path__ + "files/51c5b1a01d6c79ec7dbd6016c10e7842.png";